export const blockIconsPhotoandimageCameraNew = (
	<span className='material-symbols-outlined'>camera</span>
);
